import { hasPermission, type CurrentUser, type Permission } from '@gl/shared';

import { useSession } from './api/hooks.js';

export function useCurrentUser(): CurrentUser | null {
  const { data } = useSession();
  return data?.user ?? null;
}

/** Permission check for the signed-in user; `admin` implies everything. */
export function useCan(permission: Permission): boolean {
  const user = useCurrentUser();
  return hasPermission(user?.permissions, permission);
}

/** Start the Google sign-in flow, returning to the current page afterwards. */
export function signIn(returnTo: string = window.location.pathname + window.location.search): void {
  window.location.href = `/api/auth/google?returnTo=${encodeURIComponent(returnTo)}`;
}
